import get from 'lodash/get';
import config from '../config/config';

export const formatShortTitle = provider => {
  switch (get(provider, 'title')) {
    case 'PhD':
      return 'DPT';
    case 'DPT':
      return 'DPT';
    case 'PT':
      return 'PT';
    case 'T':
      return '';
    case 'CD':
      return 'DC';
    case 'PTA':
      return 'PTA';
    default:
      return '';
  }
};

export const formatProviderPhone = provider => {
  console.log('provider in formatProviderPhone.team:', provider.team);
  let rawNum = provider?.team?.primary_address?.phone_number || provider.facility.phone_number;
  if (rawNum && rawNum.length === 10) {
    const formattedNum = `${rawNum.slice(0,3)}-${rawNum.slice(3,6)}-${rawNum.slice(6)}`;
    return formattedNum;
  }
  return config().companyPhone;
};

export const isPersonalTrainer = provider => (
  get(provider, 'title') === 'T'
  ? true
  : false
);

export const formatProviderName = (provider, options = {includeTitle: true}) => {
  if (!provider) return '';
  let str = provider.honorific || '';
  str += ' ';
  str += provider.firstName || provider.first_name || provider?.user?.first_name || '';
  str += ' ';
  str += provider.lastName || provider.last_name || provider?.user?.last_name || '';
  if (
    options 
    && options.includeTitle 
    && provider.title 
    && ['DPT', 'PhD', 'PT', 'PTA', 'DC'].includes(provider.title)
  ) {
    str += `, ${formatShortTitle(provider)}`;
  }
  return str;
};

export const getProviderUrl = (provider, {pathOnly = true} = {}) => {
  const slug = provider.slug;
  const path = `physical-therapists/${slug}`;
  if (pathOnly) return `/${path}`;
  const hostname = window.location.hostname;
  return `${hostname}/${path}`;
};

export const calculateAverageRating = reviews => (
  reviews && reviews.length
  ? (
    reviews.reduce((acc, r) => acc + get(r, 'rating') || 0, 0)
    / reviews.length
  )
  : 0
);

export const formatProviderLocation = provider => {
  const providerCity = get(provider, 'primary_location_city') || '';
  const providerState = get(provider, 'primary_location_state') || '';
  if (!providerCity || !providerState) return null;
  const str = `${providerCity}, ${providerState}`;
  return str;
};

export const formatProviderInitials = provider => {
  if (!provider || !provider.user || !provider.user.first_name) return null;
  const firstInitial = get(provider, 'user.first_name[0]') || '';
  const lastInitial = get(provider, 'user.last_name[0]') || '';
  return `${firstInitial}${lastInitial}`;
};

export const formatProviderTitle = provider => {
  const title = get(provider, 'title');
  switch (title) {
    case 'PhD':
      return 'Doctor of Physical Therapy';
    case 'PT':
      return 'Physical Therapist';
    case 'T':
      return 'Personal Trainer';
    default:
      return '';
  }
};

export const isAdmin = providerOrUser => (
  providerOrUser?.is_superuser
  || providerOrUser?.user?.is_superuser
);

export const isBetaUser = providerOrUser => (
  providerOrUser?.is_beta_tester
  || providerOrUser?.provider?.is_beta_tester
);

const getSlug = provider => {
  if (!provider) return '';
  if (provider?.profile_path) return provider.profile_path;
  if (provider?.slug) return provider.slug;
  const firstName = provider?.user?.first_name.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '') || '';
  const lastName = provider?.user?.last_name.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '') || '';
  const slug = `${firstName}-${lastName}`;
  return slug;
};

export const getPublicProfileUrl = provider => {
  const slug = getSlug(provider);
  const bookingUrl = (
    isPersonalTrainer(provider)
    ? `/physical-therapists/${slug}`
    : `/personal-trainers/${slug}`
  );
  return bookingUrl;
};

export const getProfileImage = provider => {
  return provider.imgSrc || provider.public_profile_img_url || provider?.provider?.public_profile_img_url;
};

export const getPublicBookingUrl = provider => {
  const slug = getSlug(provider);
  const bookingUrl = (
    isPersonalTrainer(provider)
    ? `/physical-therapists/${slug}/book-now`
    : `/personal-trainers/${slug}/book-now`
  );
  return bookingUrl;
};